<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">服务人员</el-breadcrumb-item>
            <el-breadcrumb-item>个人主页</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box pro-detail__wraper">
            <div class="personal-info">
                <div class="personal-info__avatar">
                    <el-avatar style="background-color: #2d8cf0;" :size="80" :src="info.head_img">{{ info.name.substr(0,1) }}</el-avatar>
                </div>
                <div class="personal-info__bd">
                    <div class="main-info">
                        <div class="name">{{info.name}}</div>
                        <div class="rates" style="position: relative; top: -2px;">
                            <el-rate class="rate__large" :value="info.avg * 1" show-score score-template="{value}分" allow-half disabled></el-rate>
                        </div>
                        <div>（满分5分，来自 {{info.count}} 份 评价）</div>
                    </div>
                    <div class="labels">
                        <el-tag v-for="(tag, index) in info.tags" style="cursor: pointer; margin: 0 10px 10px 0;" :key="index" type="primary" plain>{{tag.tag}} {{tag.count}}</el-tag>
                    </div>
                </div>
            </div>
            <div class="divider"></div>
            <div class="personal-evaluate">
                <div class="hd">
                    <div class="title">
                        全部评价
                    </div>
                </div>
                <div class="bd">
                    <div class="abstract">
                        <div class="label">综合评价</div>
                        <div class="value">{{info.avg}}</div>
                        <div class="icon"><el-rate :value="info.avg  * 1" allow-half class="mini-size" disabled></el-rate></div>
                    </div>
                    <div class="eva-overflow">
                        <div class="summary">
                            <div class="summary-title">
                                来自发包商户评价:
                            </div>
                            <div class="summary-content">
                                <span class="summary-label">项目效率: </span><span class="summary-value">{{info.efficiency}}</span>
                            </div>
                            <div class="summary-content">
                                <span class="summary-label">项目质量: </span><span class="summary-value">{{info.quality}}</span>
                            </div>
                            <div class="summary-content">
                                <span class="summary-label">项目经济: </span><span class="summary-value">{{info.economy}}</span>
                            </div>
                        </div>
                        <div class="summary">
                            <div class="summary-title">
                                来自项目经理评价:
                            </div>
                            <div class="summary-content">
                                <span class="summary-label">业务能力: </span><span class="summary-value">{{info.capacity}}</span>
                            </div>
                            <div class="summary-content">
                                <span class="summary-label">工作效率: </span><span class="summary-value">{{info.work_efficiency}}</span>
                            </div>
                            <div class="summary-content">
                                <span class="summary-label">服务态度: </span><span class="summary-value">{{info.attitude}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <div class="box" v-for="(item, index) in evaluate" :key="index">
                        <div class="box-hd">
                            <div class="name">{{item.name}}</div>
                            <div class="type">
                                <div class="type-text">【{{typeList[item.type]}}】</div>
                            </div>
                        </div>
                        <div class="box-bd">
                            <div class="evaluate-handler">
                                <el-rate :value="item.score_avg * 1" show-score score-template="{value}分" allow-half class="mini-size" disabled></el-rate>
                                <div class="create-time">{{item.create_time}}</div>
                            </div>
                            <div class="evaluate-content">
                                {{item.content}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Evaluate',
    data () {
        return {
            evaluate: [],
            info: {
                name: '',
                tags: []
            },
            typeList: ['发包商户', '项目经理']
        }
    },
    mounted () {
        this.getEvaluate(this.$route.query.id)
    },
    methods: {
        getEvaluate (id) {
            this.$http.get('/api/user/project/appraisemember', {
                params: {
                    member_id: id
                }
            })
                .then((res) => {
                    if (res.code === 0) {
                        this.info = res.data.base
                        this.evaluate = res.data.listData
                    } else {
                        this.$Message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub.scss";
    .personal-info {
        display: flex;
        align-items: center;
        padding: 20px 0;
        .personal-info__avatar {
            width: 174px;
            height: 174px;
            padding: 40px;
            display: flex;
            align-content: center;
            overflow: hidden;
            align-items: center;
            justify-content: center;
            .el-avatar {
                width: 60px;
                height: 60px;
                line-height: 60px;
                border-radius: 50%;
                font-size: 24px;
            }
            img {
                max-width: 120px;
                max-height: 120px;
                display: block;
            }
        }
        .personal-info__bd {
            flex: 1;
        }
        .main-info {
            display: flex;
            align-items: center;
            margin-bottom: 31px;
            font-size: 14px;
            .name {
                font-size: 26px;
                font-weight: 600;
                margin-right: 24px;
            }
        }

        .labels {
            button {
                margin-right: 10px;
                margin-bottom: 10px;
            }
        }
    }

    .personal-evaluate {
        .hd {
            height: 42px;
            position: relative;
            border-bottom: 1px solid $--border-color-light;
            &>.title {
                height: 42px;
                position: absolute;
                border-top: 2px solid $--color-primary;
                border-right: 1px solid $--border-color-light;
                z-index: 1024;
                background-color: #fff;
                width: 110px;
                line-height: 43px;
                text-align: center;
                color: $--color-primary;
                font-size: 14px;
            }
        }
        .bd {
            border: 1px solid $--border-color-light;
            margin: 10px 20px;
            display: flex;
            align-items: center;
            padding: 20px;
            .abstract {
                width: 168px;
                text-align: center;
                .value {
                    color: $--color-danger;
                    font-size: 32px;
                    font-weight: 500;
                    margin: 12px 0 10px;
                }

            }
            .eva-overflow {
                padding-left: 50px;
                padding-top: 7px;
                padding-bottom: 7px;
                font-size: 14px;
                border-left: 1px solid $--border-color-light;
                .summary {
                    display: flex;
                    &:first-child {
                        margin-bottom: 26px;
                    }
                    .summary-content {
                        width: 126px;
                        text-align: center;
                        border-right: 1px solid $--border-color-light;
                        &:last-child {
                            border-right-width: 0;
                        }
                        .summary-value {
                            color: $--color-danger;
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
        .list {
            margin: 0 20px;
            .box {
                padding: 20px 15px 15px 0;
                display: flex;
                align-items: center;
                border-bottom: 1px solid $--border-color-light;
                .box-hd {
                    width: 168px;
                    text-align: center;
                    .name {
                        font-size: 14px;
                    }
                    .type {
                        margin-top: 10px;
                        color: #999;
                    }
                }
                .box-bd {
                    flex: 1;
                    margin-left: 20px;
                    .evaluate-handler {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .create-time {
                            color: #666;
                        }
                    }
                    .evaluate-content {
                        line-height: 1.5;
                        margin-top: 10px;
                    }
                }
            }
        }
    }
</style>
